import {
    createSelector,
    createSlice,
    PayloadAction,
} from '@reduxjs/toolkit';

import {TAppState} from 'store/config/types';

import {MODALS_SLICE} from './modals-slice-constants';
import {TModalData, TModalsSliceState} from './modals-slice-types';

export const modalsSlice = createSlice({
    initialState: {
        modalData: {},
    } as TModalsSliceState,
    name: MODALS_SLICE,
    reducers: {
        setModalData(state, {payload}: PayloadAction<TModalData>) {
            state.modalData = payload;
        },
        closeModal(state) {
            state.modalData = {};
        },
    },
});

const selectModalsSliceState = (state: TAppState) => state[MODALS_SLICE];

export const selectModalData = createSelector(selectModalsSliceState, state => state.modalData);

export const modalsSelectors = {
    selectModalsSliceState,
    selectModalData,
};

export const {
    reducer: modalsSliceReducer,
    actions: modalsSliceActions,
} = modalsSlice;

export const openModal = modalsSliceActions.setModalData;
export const {closeModal} = modalsSliceActions;
